import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=e47900d6&"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports